import React from 'react';

const SkinToneStep = ({ answers, setAnswers }) => {
  const options = ['خیلی روشن', 'روشن', 'متوسط', 'گندمی', 'تیره'];

  const handleSelect = (tone) => {
    setAnswers({ ...answers, skinTone: tone });
  };

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">لطفا تناژ رنگ پوست خود را انتخاب کنید</h2>
      <div className="grid grid-cols-3 gap-4">
        {options.map((option) => (
          <button
            key={option}
            onClick={() => handleSelect(option)}
            className={`p-4 rounded-lg border-2 transition-transform duration-200 focus:outline-none transform hover:scale-105 ${
              answers.skinTone === option
                ? 'border-black bg-black text-white'
                : 'border-gray-300 bg-white text-gray-800 hover:border-gray-400 hover:bg-gray-50'
            }`}
          >
            <span className="text-sm font-medium">{option}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SkinToneStep; 